// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3Raeb","modalForm":"UpgradeEpcsModal_modalForm__3Om2Q","modalFooter":"UpgradeEpcsModal_modalFooter__36kOp"};